const messages = {
  en: {
    required: "This field is required",
    emailFormat: "Enter a valid email address",
    phoneFormat:
      "Your phone number is invalid. It should be in this format 07xx xxx xxxx",
    passwordFormat:
      "Password must be more than 8 characters, including letters and digits",
    confirmPasswordFail: "password and confirm password does not match",
    passwordLength: "password must be at least 8 characters length",
    CodeLength: "Verification code length must be 6 Digits",
    image: "image size must be less than or equal to 600kb",
    imageFormat: "image format must be jpeg, jpg, png",
    pleaseUploadImage: "please upload image",
    isRequired: "is required",
  },
  ku: {
    required: "ئەم خانەیە داواکراوە",
    emailFormat: "ئیمەیلەکەت هەڵەیە.",
    phoneFormat: "ژمارەکەت هەڵەیە. پێویستە بەم شێوازە بێت 07xx xxx xxxx",
    passwordFormat:
      "پێویستە تێپەڕەوشەەکەت لە ٨ خانە کەمتر نەبێت پیت و ژمارە لەخۆبگرێت",
    confirmPasswordFail:
      "خانەی وشەی نهێنی و دڵنیابوونەوە لە وشەی نهێنی جیاوازان",
    passwordLength: "پێویستە وشەی نهێنیەکەت بە لایەنی کەمەوە ٨ خانە بێت",
    CodeLength: "پێویستە کۆدەکەت شەش خانە بێت",
    image: "قەبارەی وێنەکە پێویستە کەمتر یان یەکسان بێت بە ٦٠٠ کیلۆبایت",
    imageFormat: "جۆری وێنەکە پێویستە یەکێک لەمانە بێت jpeg, jpg, png",
    pleaseUploadImage: "پێویستە وێنەیەک دابنێت",
    isRequired: "داواکراوە",
  },
  ar: {
    required: "هذا الحقل مطلوب",
    emailFormat: "البريد الإلكتروني غير صحيح",
    phoneFormat: "رقم الهاتف غير صحيح. يجب أن يكون هذا هذه الشكل 07xx xxx xxxx",
    passwordFormat:
      "يجب أن تكون كلمة المرور أكثر من 8 أحرف ، بما في ذلك الأحرف  والأرقام",
    confirmPasswordFail: "كلمة السر وتأكيد كلمة السر غير متطابقين",
    passwordLength: "كلمة السر يجب أن تكون أكثر من 8 حروف",
    CodeLength: "يجب أن تكون كود التحقق 6 أرقام",
    image: "يجب أن يكون حجم الصورة أقل من أو تساوي 600 كيلو بايت",
    imageFormat: "يجب أن يكون صيغة الصورة jpeg, jpg, png",
    pleaseUploadImage: "يرجى رفع الصورة",
    isRequired: "مطلوب",
  },
};
export let validate = (type, input, input2,name) => {
  let language = localStorage.getItem("lang");
  if (!language) language = "en";
  if (type == "required") {
    if (input === "" || input == null) {
      return messages[language].required;
    } else {
      return null;
    }
  } else if (type == "requiredWithName") {
    if (input === "" || input == null) {
      return name +' '+ messages[language].isRequired;
    } else {
      return null;
    }
  } else if (type == "requiredArray") {
    if (input.length == 0) {
      return messages[language].required;
    } else {
      return null;
    }
  } else if (type == "email") {
    if (input === "" || input == null) {
      return messages[language].required;
    } else if (!input.includes("@") || !input.includes(".")) {
      return messages[language].emailFormat;
    } else {
      return null;
    }
  } else if (type == "phone") {
    if (input === "" || input == null) {
      return messages[language].required;
    } else if (!input.startsWith(0)) {
      return messages[language].phoneFormat;
    } else if (input.length < 11 || input.length > 11) {
      return messages[language].phoneFormat;
    } else {
      return null;
    }
  } else if (type == "confirmPassword") {
    if (input != input2) {
      return messages[language].confirmPasswordFail;
    } else {
      var lowerCaseLetters = /[a-z]/g;
      // var upperCaseLetters = /[A-Z]/g;
      var numbers = /[0-9]/g;
      if (input === "" || input == null) {
        return messages[language].required;
      } else if (
        input.length < 8 ||
        !input.match(lowerCaseLetters) ||
        // !input.match(upperCaseLetters) ||
        !input.match(numbers)
      ) {
        return messages[language].passwordFormat;
      } else {
        return null;
      }
    }
  } else if (type == "password") {
    // var lowerCaseLetters = /[a-z]/g;
    // var upperCaseLetters = /[A-Z]/g;
    // var numbers = /[0-9]/g;
    if (input === "" || input == null) {
      return messages[language].required;
    } else if (
      input.length < 8 ||
      !input.match(lowerCaseLetters) ||
      // !input.match(upperCaseLetters) ||
      !input.match(numbers)
    ) {
      return messages[language].passwordFormat;
    } else {
      return null;
    }
  } else if (type == "code") {
    if (input === "" || input == null) {
      return messages[language].required;
    } else if (input.length !== 6) {
      return messages[language].CodeLength;
    } else {
      return null;
    }
  } else if (type == "image") {
    let extention;
    if (input != null && input != "") {
      extention = input?.name.split(".").pop();
    }

    if (input === "" || input == null) {
      return messages[language].pleaseUploadImage;
    } else if (parseFloat(input.size) > 600000) {
      return messages[language].image;
    } else if (
      extention != "png" &&
      extention != "jpg" &&
      extention != "jpeg"
    ) {
      return messages[language].imageFormat;
    } else {
      return null;
    }
  }
};
